import { Accordion } from '@ark-ui/react/accordion';
import { ChevronDown } from 'lucide-react';
import { type FC } from 'react';

import { type AgentDetailsFaq } from './agent-details-content';

const ICON_STROKE_WIDTH = 1.75;

interface AgentDetailsFaqsProps {
  faqs: AgentDetailsFaq[];
}

/**
 * The FAQ rows, Figma 11473:115604: a question over a hairline, with a chevron
 * that turns when the answer is open. Any number open at once, each closable.
 * The height animation is in agent-details-dialog.css.
 */
export const AgentDetailsFaqs: FC<AgentDetailsFaqsProps> = ({ faqs }) => (
  <Accordion.Root collapsible multiple>
    {faqs.map((faq) => (
      <Accordion.Item
        className="border-b border-solid border-[var(--ds-color-border-primary)] last:border-b-0"
        key={faq.question}
        value={faq.question}
      >
        <Accordion.ItemTrigger className="flex w-full cursor-pointer items-center gap-6 py-3.5 text-left focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--ds-color-border-secondary)]">
          <span className="flex-1 text-[length:var(--ds-typography-paragraph-small-font-size)] font-[var(--ds-typography-paragraph-paragraph-medium-weight)] leading-[var(--ds-typography-paragraph-small-line-height)] text-[var(--ds-color-text-primary)]">
            {faq.question}
          </span>
          <Accordion.ItemIndicator className="agent-details-faq-indicator flex shrink-0 text-[var(--ds-color-bg-icon-primary)]">
            <ChevronDown aria-hidden="true" className="size-6" strokeWidth={ICON_STROKE_WIDTH} />
          </Accordion.ItemIndicator>
        </Accordion.ItemTrigger>
        <Accordion.ItemContent className="agent-details-faq-content overflow-hidden">
          <div className="flex flex-col gap-2 pb-3.5 text-[length:var(--ds-typography-paragraph-small-font-size)] leading-[var(--ds-typography-paragraph-small-line-height)] text-[var(--ds-color-raw-stone-600)]">
            {faq.answer !== undefined && <p>{faq.answer}</p>}
            {faq.points !== undefined && (
              <ul className="list-disc pl-5">
                {faq.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            )}
          </div>
        </Accordion.ItemContent>
      </Accordion.Item>
    ))}
  </Accordion.Root>
);
